import { ChangeDetectionStrategy, Component, HostBinding, input } from '@angular/core';

export type LoaderType = 'spinner';

@Component({
    selector: 'lib-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LoaderComponent {
	@HostBinding('style') style = 'display: inline-block';

	public readonly loaderType = input.required<LoaderType>();
}
